import { useProfileStore } from '@/store/profile.store';
import '@/styles/analytics.css';

export function WelcomeHeader() {
  const profile = useProfileStore((s) => s.profile);

  const hasName = profile?.firstName;
  const greeting = hasName ? `Welcome back, ${profile.firstName}!` : 'Welcome!';

  return (
    <div className="welcome-header">
      <div className="welcome-header__pattern" aria-hidden="true" />
      <div className="welcome-header__content">
        <h1 className="welcome-header__title">{greeting}</h1>
        <p className="welcome-header__subtitle">
          Your job search stats across all pipeline stages. Data updates as you track jobs.
        </p>
      </div>
    </div>
  );
}
